import { TranslateService } from "@ngx-translate/core";
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'onco-web';

  constructor(private translate: TranslateService) {

    this.translate.setDefaultLang('pt-BR');
    this.translate.use('pt-BR');
  }
}
